import { configureStore } from '@reduxjs/toolkit';
import campaignDetailReducer from './features/campaignDetail/campaignDetailSlice';
import campaignOptionReducer from './features/campaignOption/campaignOptionSlice';
import spreadsheetReducer from './features/spreadsheet/spreadsheetSlice';
import calculatedReducer from './features/calculated/calculatedSlice';
import burstReducer from './features/burst/burstSlice';

export const store = configureStore({
  reducer: {
    detail: campaignDetailReducer,
    option: campaignOptionReducer,
    spreadsheet: spreadsheetReducer,
    calculated: calculatedReducer,
    burst: burstReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: [
          'burst.columns.1.renderCell',
          'burst.columns.5.preProcessEditCellProps',
          'burst.columns.6.preProcessEditCellProps',
          'burst.columns.7.preProcessEditCellProps'
        ]
      }
    })
});

// Get the type of our store variable
export type AppStore = typeof store;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = AppStore['dispatch'];
